<template>
  <div>
    <router-link to="/" class="btn-back"><span>Back to Dashboard</span></router-link>
    <div class="membership-card">
      <div class="card-logo">
        <img src="/img/OHI-Logo.png" alt="OHI Logo" style="width: 80%;">
      </div>
      <div class="card-info">
        <p>
          <span class="card-label">Account Name:</span> {{ accountName }}<br>
          <span class="card-label">OHI ID:</span> {{ arvcId }}<br>
          <span class="card-label">Contact:</span> {{ form.FirstName }} {{ form.LastName }}<br>
          <span class="card-label">Expiration Date:</span> {{ termEndDate }}
        </p>
      </div>
      <div class="card-footer">
        <p class="card-bold"><span style="font-size:15px;">OHI Membership Card</span></p>
      </div>
    </div>
    <button class="print-button" @click="printCard">Print Card</button>
  </div>
</template>
<script>
import axios from 'axios';

axios.defaults.withCredentials = true;
const server = process.env.VUE_APP_API_URL;

export default {
  name: 'Membership',
  data() {
    return {
      form: {},
      accountName: '',
      arvcId: '',
      termEndDate: '',
    };
  },
  async mounted() {
    try {
      const rawContact = await axios.get(`${server}/api/contact`);
      if (rawContact.data.redirect) {
        window.location.href = rawContact.data.redirect;
        return;
      }
      console.log('Loading contact', rawContact);
      this.picklists = rawContact.data.picklists;
      this.form = rawContact.data;
      this.loading = false;
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 200);

      // Get Membership Data
      const accountId = this.$route.params.id;
      const accountResponse = await axios.get(`${server}/api/accounts/${accountId}`);
      const accountData = accountResponse.data;
      this.accountName = accountData.Name;
      this.arvcId = accountData.ARVC_Account_ID_New__c;
      this.termEndDate = accountData.FS_Membership_Expire_Date__c;
      console.log('Loading account', accountResponse);
    } catch (err) {
      console.log({ getContactError: err });
      this.loadingMessage = 'There was an issue pulling your personal info. Please let us know so we can take a look!';
    }
  },
  methods: {
    printCard() {
      window.print();
    },
  },
};
</script>

<style>
@media print {
  .print-button {
    display: none;
  }
}

.membership-card {
  position: relative;
  width: 450px;
  height: 280px;
  border: 2px solid #000;
  font-family: Helvetica, sans-serif;
}

.card-logo {
  position: absolute;
  top: 10px;
  left: 10px;
  padding-left: 3px;
}

.card-info {
  position: absolute;
  top: 30%;
  bottom: 0px;
  left: 10px;
  right: 0;
  text-align: left;
  padding: 10px;
  margin-bottom: 10px;
}

.card-label {
  font-weight: bold;
}

.card-bold {
  font-weight: bold;
  text-align: center;
  margin-top: 10px;
}

.card-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  margin-bottom: 10px;
}

.print-button {
  background-color: #005581;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;
}

.print-button:hover {
  background-color: #003a53;
}
</style>
